function AllModals() {
  return <></>;
}

export default AllModals;
